// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__MDVUO","title":"FrontImage_title__13CHI"};